/*
 * Noirève gift cart
 * - Keeps the free gift line in sync with the cart total (cart.js is the source of truth):
 *   €85+  -> free leather cardholder (colour from cart attribute _ng_color, default Black)
 *   €175+ -> free laptop sleeve (colour from _ng_carrier_color, default Black) (replaces the cardholder), unless the customer
 *            picked the cardholder instead (cart attribute _ng_gift_choice)
 * - Runs on page load, after every cart change, and again right before checkout.
 * - All cart writes go through one queue, so nothing runs twice at the same time.
 */
(function () {
  if (window.__ngInit) return;
  window.__ngInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TIMER_SECONDS = 600;
  var failed = {};
  var chain = Promise.resolve();
  var leaving = false;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function store(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function onCartPage() {
    return window.location.pathname.replace(/\/$/, '') === (root + 'cart').replace(/\/\/+/g, '/');
  }

  var configCache = null;
  function config() {
    var el = document.getElementById('ng-config');
    if (el) {
      try { configCache = JSON.parse(el.textContent); } catch (e) {}
    }
    return configCache;
  }

  function queue(fn) {
    var run = chain.then(fn);
    chain = run.catch(function (e) { console.error('[noireve-gift]', e); });
    return run;
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || ('HTTP ' + r.status));
        return j;
      });
    });
  }

  function isGift(item) { return !!(item.properties && item.properties._noireve_gift); }

  function wanted(cart, c) {
    var sub = 0;
    cart.items.forEach(function (i) { if (!isGift(i)) sub += i.final_line_price; });
    var choice = cart.attributes && cart.attributes._ng_gift_choice;
    if (c.carrier && sub >= c.t2 && choice !== 'cardholder') {
      var cc = c.carrierColors || {};
      var cid = cc[cart.attributes && cart.attributes._ng_carrier_color] || cc[c.defaultColor] || c.carrier;
      return { id: Number(cid), type: 'carrier' };
    }
    if (sub >= c.t1) {
      var colour = (cart.attributes && cart.attributes._ng_color) || c.defaultColor;
      var id = c.colors[colour] || c.colors[c.defaultColor];
      if (!id) { for (var k in c.colors) { id = c.colors[k]; break; } }
      return id ? { id: Number(id), type: 'cardholder' } : null;
    }
    return null;
  }

  /* Bring the gift lines in line with the cart total. Resolves to true if the cart changed. */
  function sync() {
    var c = config();
    if (!c) return Promise.resolve(false);
    return getCart().then(function (cart) {
      var want = wanted(cart, c);
      var updates = {};
      var have = false;
      cart.items.forEach(function (i) {
        if (!isGift(i)) return;
        if (want && !have && i.variant_id === want.id) {
          have = true;
          if (i.quantity !== 1) updates[i.key] = 1;
        } else {
          updates[i.key] = 0;
        }
      });
      var changed = false;
      var p = Promise.resolve();
      if (Object.keys(updates).length) {
        changed = true;
        p = p.then(function () { return post('cart/update.js', { updates: updates }); });
      }
      if (want && !have && !failed[want.id] && !store('ng_fail_' + want.id)) {
        changed = true;
        p = p.then(function () {
          return post('cart/add.js', { items: [{ id: want.id, quantity: 1, properties: { _noireve_gift: want.type } }] })
            .catch(function (e) { failed[want.id] = true; store('ng_fail_' + want.id, '1'); throw e; });
        });
      }
      return p.then(function () { return changed; });
    });
  }

  function updateCount() {
    var st = document.getElementById('ng-state');
    if (!st) return;
    var n = st.getAttribute('data-count');
    $$('[data-nv-cart-count]').forEach(function (el) { el.textContent = n; });
    var bubble = $('.cart-count-bubble span');
    if (bubble) bubble.textContent = n;
  }

  function bindOverlay() {
    var drawer = $('cart-drawer');
    var ov = document.getElementById('CartDrawer-Overlay');
    if (drawer && ov && !ov.__ngBound) {
      ov.__ngBound = true;
      ov.addEventListener('click', function () { drawer.close(); });
    }
  }

  /* Re-render the drawer from the server in one go. */
  function render() {
    return fetch(root + '?sections=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j['cart-drawer'];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
        var cur = document.getElementById('CartDrawer');
        if (fresh && cur) {
          var scroller = cur.querySelector('cart-drawer-items');
          var top = scroller ? scroller.scrollTop : 0;
          cur.innerHTML = fresh.innerHTML;
          var s2 = cur.querySelector('cart-drawer-items');
          if (s2) s2.scrollTop = top;
        }
        var drawer = $('cart-drawer');
        var st = document.getElementById('ng-state');
        if (drawer && st) drawer.classList.toggle('is-empty', st.getAttribute('data-has-items') !== 'true');
        bindOverlay();
        updateCount();
        tick();
      });
  }

  function openDrawer() {
    var drawer = $('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
  }

  function hideToast() {
    var t = document.getElementById('nv-toast');
    if (t) { t.classList.remove('is-on'); clearTimeout(t._h); }
  }

  function safeReload() {
    var last = Number(store('ng_reload') || 0);
    if (Date.now() - last < 5000) return decorateCartPage();
    store('ng_reload', String(Date.now()));
    window.location.reload();
  }

  /* /cart page: gift rows get a "Free gift" label instead of quantity controls. */
  function decorateCartPage() {
    if (!onCartPage() || !document.getElementById('main-cart-items')) return Promise.resolve();
    return getCart().then(function (cart) {
      cart.items.forEach(function (item, i) {
        if (!isGift(item)) return;
        var row = document.getElementById('CartItem-' + (i + 1));
        if (!row || row.classList.contains('ng-gift-row')) return;
        row.classList.add('ng-gift-row');
        var q = row.querySelector('.cart-item__quantity');
        if (q) q.innerHTML = '<span style="font-size:12px;font-weight:700;color:#2d6a3f;letter-spacing:.06em;text-transform:uppercase">Free gift</span>';
        $$('.cart-item__name', row).forEach(function (n) {
          n.removeAttribute('href');
          n.textContent = n.textContent.replace(' (Free gift)', '');
        });
      });
    });
  }

  /* After the cart changed somewhere else: fix the gift, and only re-render if needed. */
  function reconcile() {
    return queue(function () {
      return sync().then(function (changed) {
        if (!changed) return decorateCartPage();
        if (onCartPage()) { safeReload(); return; }
        return render();
      });
    });
  }

  /* Open the drawer with fresh contents (after add to bag, or clicking the bag icon). */
  function refreshAndOpen() {
    hideToast();
    return queue(function () {
      return sync().then(render).then(openDrawer);
    });
  }

  function setAttr(attrs) {
    return queue(function () {
      return post('cart/update.js', { attributes: attrs })
        .then(sync)
        .then(function () { return onCartPage() ? safeReload() : render(); });
    });
  }

  function goToCheckout(btn) {
    if (leaving) return;
    leaving = true;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var done = function () { window.location.href = root + 'checkout'; };
    // small wait so a quantity change that is still being saved goes first
    setTimeout(function () {
      queue(sync).then(done, done);
    }, 350);
  }

  function tick() {
    var st = document.getElementById('ng-state');
    var box = document.getElementById('ng-timer');
    if (!st || st.getAttribute('data-has-items') !== 'true') { store('ng_timer', null); return; }
    var start = Number(store('ng_timer'));
    if (!start) { start = Date.now(); store('ng_timer', String(start)); }
    if (!box) return;
    var rem = Math.round(TIMER_SECONDS - (Date.now() - start) / 1000);
    if (rem <= 0) { if (!box.hidden) box.hidden = true; return; }
    if (box.hidden) box.hidden = false;
    var m = Math.floor(rem / 60);
    var sec = rem % 60;
    var v = document.getElementById('ng-timer-value');
    var txt = m + ':' + (sec < 10 ? '0' : '') + sec;
    if (v && v.textContent !== txt) v.textContent = txt;
  }

  /* --- events --- */

  // Add to bag (nv.js) fires this after a successful add
  document.addEventListener('cart:refresh', function () { refreshAndOpen(); });

  document.addEventListener('click', function (e) {
    // checkout buttons and links: check the gift first
    var co = e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (co && !co.disabled) {
      e.preventDefault();
      e.stopImmediatePropagation();
      goToCheckout(co);
      return;
    }

    var sw = e.target.closest('[data-ng-color]');
    if (sw) {
      e.preventDefault();
      if (sw.classList.contains('is-on')) return;
      $$('[data-ng-color]').forEach(function (b) { b.disabled = true; });
      var attrs = {};
      attrs[sw.getAttribute('data-ng-attr') || '_ng_color'] = sw.getAttribute('data-ng-color');
      setAttr(attrs);
      return;
    }

    var ch = e.target.closest('[data-ng-choice]');
    if (ch) {
      e.preventDefault();
      ch.disabled = true;
      setAttr({ _ng_gift_choice: ch.getAttribute('data-ng-choice') });
      return;
    }

    // bag icon / "View bag": open the drawer instead of going to /cart
    var a = e.target.closest('a[href]');
    if (a && $('cart-drawer') && !e.metaKey && !e.ctrlKey && !e.shiftKey && !onCartPage()) {
      var path;
      try { path = new URL(a.href, window.location.href).pathname.replace(/\/$/, ''); } catch (err) { return; }
      if (path === (root + 'cart').replace(/\/\/+/g, '/')) {
        e.preventDefault();
        refreshAndOpen();
      }
    }
  }, true);

  // Enter key in a quantity field etc. submits the form: treat as checkout only if it is a checkout submit
  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.name === 'checkout') {
      e.preventDefault();
      goToCheckout(s);
    }
  }, true);

  // Quantity changes and removals (Dawn cart.js publishes cartUpdate)
  function hookPubSub() {
    // PUB_SUB_EVENTS is a top-level const in Dawn's constants.js, so it is not on window
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { reconcile(); });
      return true;
    }
    return false;
  }

  // Back/forward cache: the page may come back with an old cart
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { leaving = false; reconcile(); }
  });

  function init() {
    if (!hookPubSub()) setTimeout(hookPubSub, 500);
    bindOverlay();
    updateCount();
    tick();
    setInterval(tick, 1000);
    reconcile();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
